
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('g',{attrs:{"fill":"#000"}},[_c('path',{attrs:{"d":"M10.125 10.545h1.688V20.67h-1.688zM15.188 10.545h1.687V20.67h-1.688z"}}),_c('path',{attrs:{"d":"M3.375 5.483V7.17h1.688v16.875c0 .932.755 1.688 1.687 1.688h13.5c.932 0 1.688-.756 1.688-1.688V7.17h1.687V5.483H3.375zM6.75 24.045V7.17h13.5v16.875H6.75zM10.125 2.108h6.75v1.687h-6.75z"}})]),_c('path',{attrs:{"d":"M0 .42h27v27H0z"}})])])
          )
        }
      }
    